module.exports = __webpack_public_path__ + "img/googleCloude.0daeccc9.png";